import { FC } from 'react'
import TSvgProps from './type/svgPropsType'

const MentorApproveIcon: FC<TSvgProps> = (props) => {
  return (
    <svg
      width="41"
      height="41"
      viewBox="0 0 41 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <desc>멘토 승인 아이콘</desc>
      <g clipPath="url(#clip0_979_108)">
        <path
          d="M20.5 40.5C31.5457 40.5 40.5 31.5457 40.5 20.5C40.5 9.4543 31.5457 0.5 20.5 0.5C9.4543 0.5 0.5 9.4543 0.5 20.5C0.5 31.5457 9.4543 40.5 20.5 40.5Z"
          fill="white"
          stroke="#EEEEEE"
        />
        <path
          d="M29.9009 19.032C29.6514 18.7806 29.4705 18.4694 29.3756 18.1282C29.2807 17.7869 29.275 17.4271 29.3589 17.083L29.3749 17.017C29.5028 16.4927 29.4209 15.9393 29.1467 15.4745C28.8725 15.0098 28.4276 14.6705 27.9069 14.529C27.5651 14.436 27.2529 14.257 27 14.0089C26.7472 13.7608 26.5623 13.452 26.4629 13.112L26.4439 13.047C26.2926 12.529 25.945 12.0907 25.4753 11.8252C25.0055 11.5598 24.4507 11.4883 23.9289 11.626C23.5865 11.7164 23.2265 11.7175 22.8835 11.6291C22.5405 11.5407 22.226 11.3657 21.9699 11.121L21.9219 11.074C21.532 10.7008 21.0118 10.4947 20.4721 10.4996C19.9325 10.5045 19.4161 10.7199 19.0329 11.1C18.7816 11.3495 18.4704 11.5304 18.1292 11.6253C17.7879 11.7202 17.428 11.7259 17.0839 11.642L17.0179 11.626C16.4937 11.4981 15.9403 11.58 15.4755 11.8542C15.0108 12.1284 14.6715 12.5733 14.5299 13.094C14.437 13.4358 14.258 13.748 14.0099 14.0009C13.7618 14.2537 13.4529 14.4386 13.1129 14.538L13.0479 14.557C12.53 14.7083 12.0916 15.0558 11.8262 15.5256C11.5608 15.9954 11.4893 16.5502 11.6269 17.072C11.7173 17.4145 11.7182 17.7745 11.6296 18.1175C11.541 18.4605 11.3659 18.775 11.1209 19.031L11.0749 19.08C10.7018 19.4699 10.4957 19.9901 10.5006 20.5297C10.5054 21.0694 10.7209 21.5858 11.1009 21.969C11.3505 22.2203 11.5313 22.5315 11.6262 22.8727C11.7211 23.214 11.7269 23.5739 11.6429 23.918L11.6269 23.984C11.4991 24.5082 11.581 25.0616 11.8552 25.5264C12.1294 25.9911 12.5742 26.3304 13.0949 26.472C13.4368 26.5649 13.749 26.7439 14.0018 26.992C14.2547 27.2401 14.4396 27.549 14.5389 27.889L14.5579 27.954C14.7093 28.4719 15.0568 28.9102 15.5266 29.1757C15.9964 29.4411 16.5512 29.5126 17.0729 29.375C17.4154 29.2845 17.7753 29.2834 18.1183 29.3718C18.4613 29.4603 18.7759 29.6352 19.0319 29.88L19.0809 29.927C19.471 30.2999 19.9913 30.5059 20.5309 30.5008C21.0706 30.4958 21.5869 30.2802 21.9699 29.9C22.2213 29.6504 22.5325 29.4696 22.8737 29.3747C23.215 29.2798 23.5748 29.274 23.9189 29.358L23.9849 29.374C24.5092 29.5018 25.0626 29.4199 25.5273 29.1457C25.9921 28.8715 26.3314 28.4267 26.4729 27.906C26.5658 27.5641 26.7449 27.2519 26.993 26.9991C27.2411 26.7462 27.5499 26.5613 27.8899 26.462L27.9549 26.443C28.4729 26.2916 28.9112 25.9441 29.1766 25.4743C29.4421 25.0045 29.5136 24.4497 29.3759 23.928C29.2855 23.5855 29.2844 23.2256 29.3728 22.8826C29.4612 22.5396 29.6362 22.225 29.8809 21.969L29.9279 21.92C30.3006 21.53 30.5064 21.0099 30.5013 20.4705C30.4963 19.9311 30.2809 19.4149 29.9009 19.032Z"
          fill="#01A0FF"
          stroke="#01A0FF"
        />
        <path
          d="M16.814 20.8767L19.86 23.5297L24.188 17.4688"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_979_108">
          <rect width="41" height="41" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default MentorApproveIcon
